module.exports = __webpack_public_path__ + "img/blue-circle-table-10.23c2d7c6.png";